<template>
  <div class="app-container">
    <div class="filter-container" style="position: relative; display: flex">
      <!-- 其他按钮 -->
      <el-button v-if="$canEdit" @click="addLog" size="small" type="primary"
        >导入订单对账</el-button
      >

      <!-- 下载按钮右对齐 -->
      <div style="margin-left: auto">
        <download-excel
          :fields="json_fields2"
          :fetch="handleExport2"
          type="xls"
          name="遂穿订单对账.xls"
          worksheet="遂穿订单对账"
        >
          <el-button size="small" type="success" :loading="exportLoading2">
            下载Excel
          </el-button>
        </download-excel>
      </div>
    </div>
    <div class="filter-container" style="position: relative" v-if="$canEdit">
      <el-checkbox
        v-model="selectAll"
        style="margin-right: 15px"
        @change="handleSelectAll"
        >全选</el-checkbox
      >
      <el-button @click="handleBatchProcess" size="small" type="primary"
        >批量处理</el-button
      >
      <el-button @click="handleBatchRevoke" size="small" type="primary"
        >批量退回</el-button
      >
    </div>
    <div
      v-if="detailId"
      class="filter-container"
      style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center"
    >
      <el-input
        v-model="detailFilter.system_order_no"
        size="small"
        placeholder="系统订单号"
        clearable
        style="width: 150px"
      />
      <el-input
        v-model="detailFilter.order_code"
        size="small"
        placeholder="遂穿订单号"
        clearable
        style="width: 150px"
      />
      <el-select
        v-model="detailFilter.prompt_type"
        size="small"
        placeholder="提示类型"
        clearable
        style="width: 150px"
      >
        <el-option label="金额对不上" value="amount_mismatch" />
        <el-option label="系统多出" value="system_extra" />
        <el-option label="Excel多出" value="excel_extra" />
      </el-select>
      <el-select
        v-model="detailFilter.is_handled"
        size="small"
        placeholder="处理状态"
        clearable
        style="width: 150px"
      >
        <el-option label="未处理" :value="0" />
        <el-option label="已处理" :value="1" />
      </el-select>
      <el-button
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button size="small" @click="handleDetailReset">重置</el-button>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="listLoading"
      :data="list"
      :row-class-name="tableRowClassName"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="$canEdit"
        align="center"
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column align="center" label="序号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column width="100" align="center" label="提示">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.prompt_type == 'excel_extra'" type="danger"
            >Excel多出</el-tag
          >
          <el-tag
            v-else-if="scope.row.prompt_type == 'system_extra'"
            type="primary"
            >系统多出</el-tag
          >
          <el-tag
            v-else-if="scope.row.prompt_type == 'amount_mismatch'"
            type="warning"
            >金额对不上</el-tag
          >
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="系统订单号">
        <template slot-scope="scope">
          {{ scope.row.system_order_no }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="遂穿订单号">
        <template slot-scope="scope">
          {{ scope.row.order_code || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="系统遂穿成本">
        <template slot-scope="scope">
          {{ scope.row.system_cost }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="遂穿实际账期成本">
        <template slot-scope="scope">
          {{ scope.row.actual_system_cost }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="Excel遂穿成本">
        <template slot-scope="scope">
          {{ scope.row.cost }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="渠道销售价">
        <template slot-scope="scope">
          {{ scope.row.channel_money }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="渠道价实际账期">
        <template slot-scope="scope">
          {{ scope.row.actual_channel_money }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="预订人">
        <template slot-scope="scope">
          {{ scope.row.link_man }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="实际离店时间">
        <template slot-scope="scope">
          {{ scope.row.actual_end_travel_date }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="是否处理">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.is_handled === 1 || scope.row.is_handled === true
                ? 'success'
                : 'info'
            "
            size="small"
          >
            {{
              scope.row.is_handled === 1 || scope.row.is_handled === true
                ? '已处理'
                : '未处理'
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button
            v-if="$canEdit"
            size="mini"
            type="primary"
            :disabled="scope.row.is_handled"
            @click="handleProcess(scope.row)"
          >
            处理
          </el-button>
          <el-button
            v-if="$canEdit"
            size="mini"
            type="danger"
            :disabled="!scope.row.is_handled"
            @click="handleReject(scope.row)"
          >
            退回
          </el-button>
          <div style="margin-top: 5px">
            <el-button
              size="mini"
              type="primary"
              @click="showOperationLog(scope.row)"
            >
              订单操作日志
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next,  jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="导入订单对账"
      :visible.sync="showaddLog"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="addLogform"
        :model="addLogform"
        :rules="addLogRules"
        label-width="0px"
      >
        <el-form-item>
          <el-date-picker
            v-model="addLogform.date"
            type="daterange"
            @change="changeaddLogformdata"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-row type="flex">
          <el-col :span="8">
            <el-upload
              class="filter-item"
              accept=".xlsx,.xls"
              action=""
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleImportUsers"
            >
              <el-button type="warning" icon="el-icon-upload" size="small">
                订单对账导入
              </el-button>
            </el-upload>
          </el-col>
          <el-button
            class="filter-item"
            type="primary"
            @click="downloadExcel"
            size="small"
          >
            下载订单对账模板
          </el-button>
        </el-row>
        <div style="height: 500px" class="scrollbar">
          <el-scrollbar style="height: 500px">
            <el-table :data="addLogform.orders" style="width: 1100px">
              <el-table-column label="系统订单号" min-width="60" align="center">
                <template slot-scope="scope">
                  {{ scope.row.system_order_no || '' }}
                </template>
              </el-table-column>
              <el-table-column
                label="遂穿支付成本"
                min-width="60"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.total_rate || '' }}
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </div>
        <el-row type="flex" justify="end">
          <el-button @click="showaddLog = false">取消</el-button>
          <el-button type="primary" @click="postaddLog">确认</el-button>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 订单操作日志弹窗 -->
    <el-dialog
      title="订单操作日志"
      :visible.sync="operationLogVisible"
      :close-on-click-modal="false"
      width="80%"
      top="30px"
      @closed="currentOperationRow = null"
    >
      <operationLog
        v-if="operationLogVisible && currentOperationRow"
        :reconciliationLogId="reconciliation_log_id"
        :systemOrderNo="currentOperationRow.system_order_no"
        targetType="sui_chuan"
        dialogMode
      />
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import downloadExcel from 'vue-json-excel'
import { excel2Json } from '@/utils/excel'
import moment from 'moment'
import OperationLog from './OperationLog.vue'

export default {
  components: { downloadExcel, OperationLog },
  data() {
    return {
      showaddLog: false,
      addLogRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      addLogform: {
        date: '',
        start_date: '',
        end_date: '',
      },
      list: null,
      total: null,
      listLoading: false,
      exportLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        start_at: '',
        end_at: '',
      },
      userLogsid: '',
      viplist: [],
      selectAll: false,
      multipleSelection: [],
      reconciliation_log_id: '',
      detailId: '',
      detailFilter: {
        system_order_no: '',
        order_code: '',
        prompt_type: '',
        is_handled: '',
      },
      operationLogVisible: false,
      currentOperationRow: null,
      json_fields: {
        发放人数: {
          field: 'user_num',
          //自定义回调函数

          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        发放时间: {
          field: 'created_at',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
      },
      exportLoading2: false,
      json_fields2: {
        提示: {
          field: 'prompt_type',
          callback: (value) => {
            const map = {
              excel_extra: 'Excel多出',
              system_extra: '系统多出',
              amount_mismatch: '金额对不上',
            }
            const text = map[value] || value || ''
            return '<p style="mso-number-format:\'\\@\';">' + text + '</p>'
          },
        },
        系统订单号: {
          field: 'system_order_no',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        遂穿订单号: {
          field: 'order_code',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        系统遂穿成本: {
          field: 'system_cost',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        Excel遂穿成本: {
          field: 'cost',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        渠道销售价: {
          field: 'channel_money',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        遂穿实际账期成本: {
          field: 'actual_system_cost',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        渠道价实际账期: {
          field: 'actual_channel_money',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        预定人: {
          field: 'link_man',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        实际离店时间: {
          field: 'actual_end_travel_date',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        是否处理: {
          field: 'is_processed',
          callback: (value) => {
            const text = value === 1 || value === true ? '已处理' : '未处理'
            return '<p style="mso-number-format:\'\\@\';">' + text + '</p>'
          },
        },
        处理时间: {
          field: 'processed_at',
          callback: (value) => {
            return (
              '<p style="mso-number-format:\'\\@\';">' + (value || '') + '</p>'
            )
          },
        },
        操作人: {
          field: 'operator',
          callback: (value) => {
            return (
              '<p style="mso-number-format:\'\\@\';">' + (value || '') + '</p>'
            )
          },
        },
      },
    }
  },
  created() {
    // 如果有 id 参数，则加载对账记录详情
    const detailId = this.$route.query.id
    if (detailId) {
      this.fetchReconciliationDetail(detailId)
    }
  },
  watch: {
    showaddLog() {
      this.addLogform = {
        orders: [],
        date: '',
        end_travel_date_start_at: '',
        end_travel_date_end_at: '',
      }
    },
  },
  computed: {
    //状态：none：未处理 ； pending：处理中 ；completed：已完成； revoke_pending ：撤销处理中；revoked：已撤销
    status() {
      return (val) => {
        switch (val) {
          case 'none':
            return '未处理'
          case 'pending':
            return '处理中'
          case 'completed':
            return '已完成'
          case 'revoke_pending':
            return '撤销处理中'
          case 'revoked':
            return '已撤销'
        }
      }
    },
    revenue_type() {
      return (val) => {
        switch (val) {
          case 'retail_bonus':
            return '零售奖励'
          case 'referral_bonus':
            return '推荐奖励'
          case 'distribution_bonus':
            return '分销奖励'
          case 'expansion_bonus':
            return '级差奖励'
          case 'welfare_bonus':
            return '福利奖励'
          case 'founder_bonus':
            return '创始人分红'
          case 'vip_bonus':
            return 'VIP 分红'
          case 'super_vip_bonus':
            return '钻石分红'
        }
      }
    },
  },
  methods: {
    tableRowClassName({ row }) {
      const systemCost = Number(row.actual_system_cost)
      const jinJiangCost = Number(row.cost)

      if (systemCost === 0) {
        console.log(systemCost)
        return 'row-red'
      }

      if (jinJiangCost === 0) {
        return 'row-blue'
      }

      if (systemCost > 0 && jinJiangCost > 0 && systemCost !== jinJiangCost) {
        return 'row-yellow'
      }

      return ''
    },
    tableRowRemark(row) {
      const systemCost = Number(row.actual_system_cost)
      const jinJiangCost = Number(row.cost)

      if (systemCost === 0) {
        console.log(systemCost)
        return 'Excel多出'
      }

      if (jinJiangCost === 0) {
        return '系统多出'
      }

      if (systemCost > 0 && jinJiangCost > 0 && systemCost !== jinJiangCost) {
        return '金额对不上'
      }

      return ''
    },

    addLog() {
      this.showaddLog = true
    },
    downloadExcel() {
      let a = document.createElement('a')
      a.href = '/订单对账模板.xlsx'
      a.download = '订单对账模板.xlsx'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    postaddLog() {
      if (
        !this.addLogform.end_travel_date_start_at ||
        !this.addLogform.end_travel_date_end_at
      ) {
        this.$message.warning('请选择开始与结束日期')
        return
      }
      this.addLogform.target_type = this.listQuery.target_type
      this.addLogform.end_travel_date_start_at = moment(
        this.addLogform.end_travel_date_start_at,
      ).format('YYYY-MM-DD 00:00:00')
      this.addLogform.end_travel_date_end_at = moment(
        this.addLogform.end_travel_date_end_at,
      ).format('YYYY-MM-DD 23:59:59')
      return request({
        url: '/api/backend/suiChuan/reconciliation-log/create-log',
        method: 'POST',
        data: this.addLogform,
      })
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '操作成功',
            })
            this.showaddLog = false
            this.fetchReconciliationDetail(res.data.reconciliation_log_id)
            // this.reconciliation_log_id = res.data.reconciliation_log_id
          }
        })
        .finally((val) => {
          console.log(val)
        })
    },
    handleImportUsers(file) {
      file = file.raw
      if (
        !(file.name.split('.')[1] == 'xlsx' || file.name.split('.')[1] == 'xls')
      ) {
        this.$message.error('上传文件格式不正确，请检查选择的文件')
        return
      }
      excel2Json(file, 1).then((excelData) => {
        console.log(excelData)
        // 处理业务
        if (excelData.length <= 0) {
          this.$message.error('数据不能为空')
          return
        }
        excelData.forEach((element, index) => {
          if (element['系统订单号']) {
            this.addLogform.orders.push({
              system_order_no: element['系统订单号'] + '',
              total_rate: element['供应商支付成本'],
            })
          }
          console.log(element, '--------', index)
        })
        this.importDataDialogVisible = true
        console.log(this.addLogform.orders, '=============')
      })
    },
    changedata(val) {
      console.log(val)
      if (val) {
        this.listQuery.start_at = val[0]
        this.listQuery.end_at = val[1]
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    changeaddLogformdata(val) {
      console.log(val)
      if (val) {
        this.addLogform.end_travel_date_start_at = val[0]
        this.addLogform.end_travel_date_end_at = val[1]
      } else {
        this.addLogform.end_travel_date_start_at = ''
        this.addLogform.end_travel_date_end_at = ''
      }
    },
    handleExport2() {
      this.exportLoading2 = true
      return request({
        url: '/api/backend/suiChuan/reconciliation-log/detail-list',
        method: 'get',
        params: {
          id: this.detailId,
          page: 1,
          limit: 99999,
          system_order_no: this.detailFilter.system_order_no || undefined,
          order_code: this.detailFilter.order_code || undefined,
          prompt_type: this.detailFilter.prompt_type || undefined,
          is_handled:
            this.detailFilter.is_handled !== '' &&
            this.detailFilter.is_handled !== null
              ? this.detailFilter.is_handled
              : undefined,
        },
      })
        .then((response) => {
          return response.data.data || []
        })
        .catch(() => {
          this.$message.error('导出失败')
          return []
        })
        .finally(() => {
          this.exportLoading2 = false
        })
    },
    handleDetailFilter() {
      if (!this.detailId) return
      this.listLoading = true
      request({
        url: '/api/backend/suiChuan/reconciliation-log/detail-list',
        method: 'get',
        params: {
          id: this.detailId,
          page: this.listQuery.page,
          limit: this.listQuery.limit,
          system_order_no: this.detailFilter.system_order_no || undefined,
          order_code: this.detailFilter.order_code || undefined,
          prompt_type: this.detailFilter.prompt_type || undefined,
          is_handled:
            this.detailFilter.is_handled !== '' &&
            this.detailFilter.is_handled !== null
              ? this.detailFilter.is_handled
              : undefined,
        },
      })
        .then((response) => {
          console.log(response)

          this.list = response.data.data || []
          this.total = response.data.total || 0
        })
        .catch(() => {
          this.$message.error('筛选失败')
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleDetailReset() {
      this.detailFilter = {
        system_order_no: '',
        order_code: '',
        prompt_type: '',
        is_handled: '',
      }
      if (this.detailId) {
        this.listQuery.page = 1
        this.handleDetailFilter()
      }
    },
    fetchReconciliationDetail(id) {
      this.detailId = id
      this.reconciliation_log_id = id
      this.listQuery.page = 1
      this.handleDetailFilter()
    },
    handleFilter() {
      this.listQuery.page = 1
      this.handleDetailFilter()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.handleDetailFilter()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.handleDetailFilter()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSelectAll(val) {
      this.$refs.multipleTable.clearSelection()
      if (val) {
        this.list.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, true)
        })
      }
    },
    handleProcess(row) {
      this.$confirm('确认处理该订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const currentPage = this.listQuery.page
          request({
            url: '/api/backend/suiChuan/reconciliation-log/batch-handle',
            method: 'post',
            data: {
              reconciliation_log_id: this.reconciliation_log_id,
              system_order_nos: [row.system_order_no],
            },
          }).then((res) => {
            if (res.code == 0) {
              // row.is_handled = 1
              this.listQuery.page = currentPage
              if (this.detailId) {
                this.handleDetailFilter()
              } else {
                this.fetchReconciliationDetail(this.reconciliation_log_id)
              }
              this.$message({
                type: 'success',
                message: '处理成功',
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    handleBatchProcess() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请先选择需要处理的订单')
        return
      }
      if (!this.reconciliation_log_id) {
        this.$message.warning('缺少对账记录ID')
        return
      }
      this.$confirm(
        `确认批量处理 ${this.multipleSelection.length} 条订单？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          const currentPage = this.listQuery.page
          request({
            url: '/api/backend/suiChuan/reconciliation-log/batch-handle',
            method: 'post',
            data: {
              reconciliation_log_id: this.reconciliation_log_id,
              system_order_nos: this.multipleSelection.map(
                (row) => row.system_order_no,
              ),
            },
          }).then((res) => {
            if (res.code == 0) {
              this.selectAll = false
              this.listQuery.page = currentPage
              if (this.detailId) {
                this.handleDetailFilter()
              } else {
                this.fetchReconciliationDetail(this.reconciliation_log_id)
              }

              this.$message({
                type: 'success',
                message: '批量处理成功',
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    handleBatchRevoke() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请先选择需要退回的订单')
        return
      }
      if (!this.reconciliation_log_id) {
        this.$message.warning('缺少对账记录ID')
        return
      }
      this.$confirm(
        `确认批量退回 ${this.multipleSelection.length} 条订单？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          const currentPage = this.listQuery.page
          request({
            url: '/api/backend/suiChuan/reconciliation-log/batch-revoke',
            method: 'post',
            data: {
              reconciliation_log_id: this.reconciliation_log_id,
              system_order_nos: this.multipleSelection.map(
                (row) => row.system_order_no,
              ),
            },
          }).then((res) => {
            if (res.code == 0) {
              this.selectAll = false
              this.listQuery.page = currentPage
              if (this.detailId) {
                this.handleDetailFilter()
              } else {
                this.fetchReconciliationDetail(this.reconciliation_log_id)
              }

              this.$message({
                type: 'success',
                message: '批量退回成功',
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    handleReject(row) {
      this.$confirm('确认退回该订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const currentPage = this.listQuery.page
          request({
            url: '/api/backend/suiChuan/reconciliation-log/batch-revoke',
            method: 'post',
            data: {
              reconciliation_log_id: this.reconciliation_log_id,
              system_order_nos: [row.system_order_no],
            },
          }).then((res) => {
            if (res.code == 0) {
              // row.is_handled = 2
              this.listQuery.page = currentPage
              if (this.detailId) {
                this.handleDetailFilter()
              } else {
                this.fetchReconciliationDetail(this.reconciliation_log_id)
              }
              this.$message({
                type: 'success',
                message: '已退回',
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    showOperationLog(row) {
      this.currentOperationRow = row
      this.operationLogVisible = true
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}

::v-deep .row-red {
  background-color: #ffecec !important;
}

::v-deep .row-blue {
  background-color: #e0f0ff !important;
}

::v-deep .row-yellow {
  background-color: #fffbe0 !important;
}
</style>
